module.exports = __webpack_public_path__ + "static/media/play-board-1.18368bd8.png";